// Version : 0.0.1
// Author : Vignesh
import IndividualLoanActionTypes from './individual-loan-proposal.types';

/** ***************** ADD INDIVIDUAL LOAN PROPOSAL START ***************** */
export const addIndividualLoanProposalStart = (addData: any) => ({
	type: IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_START,
	payload: addData,
});

export const addIndividualLoanProposalSuccess = (successData: any) => ({
	type: IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addIndividualLoanProposalFailure = (failureData: any) => ({
	type: IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addIndividualLoanProposalResponseReset = () => ({
	type: IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addIndividualLoanProposalListResponseChanged = () => ({
	type: IndividualLoanActionTypes.ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** ADD INDIVIDUAL LOAN PROPOSAL END ************ */

/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL START ***************** */
export const updateIndividualLoanProposalStart = (updateData: any) => ({
	type: IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_START,
	payload: updateData,
});

export const updateIndividualLoanProposalSuccess = (successData: any) => ({
	type: IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateIndividualLoanProposalFailure = (failureData: any) => ({
	type: IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateIndividualLoanProposalResponseReset = () => ({
	type: IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateIndividualLoanProposalListResponseChanged = () => ({
	type: IndividualLoanActionTypes.UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL END ************ */

/** ***************** SEARCH MEMBER INDIVIDUAL LOAN PROPOSAL START ***************** */
export const searchMemberLoanProposalStart = (getData: any) => ({
	type: IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_START,
	payload: getData,
});

export const searchMemberLoanProposalSuccess = (successData: any) => ({
	type: IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const searchMemberLoanProposalFailure = (failureData: any) => ({
	type: IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const searchMemberLoanProposalResponseReset = () => ({
	type: IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const searchMemberLoanProposalListResponseChanged = () => ({
	type: IndividualLoanActionTypes.SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_CHANGED,
});
/** ***************** SEARCH MEMBER INDIVIDUAL LOAN PROPOSAL END ************ */
